import { Inject, Injectable } from '@angular/core';
import { isNil } from 'lodash-es';
import { environment } from '../environments/environment';

import { UtilsService } from './utils.service';
import { SettingsValuesService } from './settings.values.service';

@Injectable({ providedIn: 'root' })
export class Inventory_ds_get_available_inventory_by_materialIds_packagedIds_warehouseIds_batchedService {

  constructor(
    private $utils: UtilsService,
    private $settings: SettingsValuesService,
    ) { 
  }

  public async get($inParams: { materialIds: number[], packagedIds: number[], warehouseIds: number[] }): 
  Promise<{ result: { TotalAvailablePackagedAmount?: number, TotalAvailableBaseAmount?: number, TotalInactiveBaseAmount?: number, TotalInactivePackagedAmount?: number, TotalSoftAllocatedBaseAmount?: number, TotalSoftAllocatedPackagedAmount?: number, MaterialId?: number, PackagedId?: number, WarehouseId?: number }[] }> 
  {
    const $missingRequiredInParams = [];
    if (isNil($inParams.materialIds)) {
      $missingRequiredInParams.push('\'materialIds\'');
    }
    if (isNil($inParams.packagedIds)) {
      $missingRequiredInParams.push('\'packagedIds\'');
    }
    if (isNil($inParams.warehouseIds)) {
      $missingRequiredInParams.push('\'warehouseIds\'');
    }
    if ($missingRequiredInParams.length) {
    }
    let $url = `${environment.backendUrl}api/`;
    
    const $options = {
    }
    
    const $body = $inParams;
    
    return this.$utils.http.post($url, $body, $options);
    
  }
  public async getList($inParams: { materialIds: number[], packagedIds: number[], warehouseIds: number[], $top?: number, $skip?: number }): 
  Promise<{ result: { TotalAvailablePackagedAmount?: number, TotalAvailableBaseAmount?: number, TotalInactiveBaseAmount?: number, TotalInactivePackagedAmount?: number, TotalSoftAllocatedBaseAmount?: number, TotalSoftAllocatedPackagedAmount?: number, MaterialId?: number, PackagedId?: number, WarehouseId?: number }[], totalCount: number }> 
  {
    const $missingRequiredInParams = [];
    if (isNil($inParams.materialIds)) {
      $missingRequiredInParams.push('\'materialIds\'');
    }
    if (isNil($inParams.packagedIds)) {
      $missingRequiredInParams.push('\'packagedIds\'');
    }
    if (isNil($inParams.warehouseIds)) {
      $missingRequiredInParams.push('\'warehouseIds\'');
    }
    if ($missingRequiredInParams.length) {
    }
    let $url = `${environment.backendUrl}api/`;
    
    const $options = {
    }
    
    const $body = $inParams;
    
    return this.$utils.http.post($url, $body, $options);
    
  }
  public async getByKeys($inParams: { materialIds: number[], packagedIds: number[], warehouseIds: number[], $keys: { MaterialId?: number, PackagedId?: number, WarehouseId?: number }[] }): 
  Promise<{ result: { TotalAvailablePackagedAmount?: number, TotalAvailableBaseAmount?: number, TotalInactiveBaseAmount?: number, TotalInactivePackagedAmount?: number, TotalSoftAllocatedBaseAmount?: number, TotalSoftAllocatedPackagedAmount?: number, MaterialId?: number, PackagedId?: number, WarehouseId?: number }[] }> 
  {
    const $missingRequiredInParams = [];
    if (isNil($inParams.materialIds)) {
      $missingRequiredInParams.push('\'materialIds\'');
    }
    if (isNil($inParams.packagedIds)) {
      $missingRequiredInParams.push('\'packagedIds\'');
    }
    if (isNil($inParams.warehouseIds)) {
      $missingRequiredInParams.push('\'warehouseIds\'');
    }
    if (isNil($inParams.$keys)) {
      $missingRequiredInParams.push('\'$keys\'');
    }
    if ($missingRequiredInParams.length) {
    }
    let $url = `${environment.backendUrl}api/`;
    
    const $options = {
    }
    
    const $body = $inParams;
    
    return this.$utils.http.post($url, $body, $options);
    
  }


    
    hasMissingRequiredInParams($inParams: { 
      materialIds: number[], packagedIds: number[], warehouseIds: number[]    }) {
        if(isNil($inParams.materialIds)) {
          return true; 
        }
        if(isNil($inParams.packagedIds)) {
          return true; 
        }
        if(isNil($inParams.warehouseIds)) {
          return true; 
        }
      return false;
    }
}
